export function setByPath(obj: any, path: string[], value: any) {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }

  if (!Array.isArray(path) || path.length === 0) {
    return obj;
  }

  let current = obj;

  for (let i = 0; i < path.length - 1; i++) {
    const key = path[i];

    if (current[key] == null || typeof current[key] !== 'object') {
      current[key] = {};
    }

    current = current[key];
  }

  current[path[path.length - 1]] = value;

  return obj;
}

export function deepMerge<T extends Record<string, any>>(
  target: T,
  source: Partial<T>,
): T {
  const output = { ...target };

  for (const key in source) {
    const value = source[key];

    // If explicitly undefined → remove from output
    if (value === undefined) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete output[key];
      continue;
    }

    // Deep merge if both sides are non-null objects
    if (
      typeof value === 'object' &&
      value !== null &&
      !Array.isArray(value) &&
      typeof target[key] === 'object' &&
      target[key] !== null &&
      !Array.isArray(target[key])
    ) {
      output[key] = deepMerge(target[key], value);
    } else {
      output[key] = value as T[Extract<keyof T, string>];
    }
  }

  return output;
}

export function deepMergeObjects(
  objects: Record<string, unknown>[],
): Record<string, unknown> {
  return objects.reduce((acc, obj) => deepMerge(acc, obj), {});
}

export function isPlainObject(value: object): boolean {
  return (
    value !== null &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    Object.prototype.toString.call(value) === '[object Object]'
  );
}
